<template>
  <div>
    <product-movement-form
      :create="create"
      :view="view"
      :change="change"
      @close="$router.push('/admin/productMovement/list')"
      @list="$router.push('/admin/productMovement/list')"
      @change="id=> $router.push('/admin/productMovement/change?id=' + id)"
      @view="id=> $router.push('/admin/productMovement/view?id=' + id)"
    />
  </div>
</template>
<script >

import ProductMovementForm from "@/views/admin/components/ProductMovement-form.vue"

export default {
  components: { ProductMovementForm },
  props: ['create', 'change', 'view'],
  mounted () {
    console.log('ProductMovement-page.vue is loaded')
  },
}
</script>

<style scoped>

</style>
